<template>
  <div class="page">
    <iframe
      class="frame"
      title="Privacy Policy"
      src="/privacy/"
      referrerpolicy="no-referrer"
    />
  </div>
  
</template>

<script setup lang="ts">
</script>

<style scoped>
.page {
  position: fixed;
  inset: 0;
  background: #000;
}
.frame {
  width: 100%;
  height: 100%;
  border: 0;
  background: #fff;
}
</style>


